import React from "react";
import PropTypes from "prop-types";

import withForm from "../../shared/Form";
import { FileInput, TextInput, TextEditor, SelectInput, GroupCollection } from "../../shared/Forms";
import { URL, EMAIL, BUNDLE_ID, APPLE_TAGS } from "../../../constants";

import {
	androidCategories,
	appleCategories,
	appleSubCategories,
	devices as screenshotDevices,
	getTerritoryList,
} from "./data";
import ScreenshotList from "./ScreenshotList";

class Form extends React.Component {
	state = {
		screenshotsExpanded: {
			screenshotsAppleXsMax: false,
			screenshotsApple6sPlus: false,
			screenshotsAppleiPadGen2: false,
			screenshotsAppleiPadGen3: false,
			screenshotsAndroid: false,
		},
	};

	toggleCollectionItem = index => {
		const { expandedIndex } = this.state;
		if (expandedIndex === index) {
			this.setState({
				expandedIndex: null,
			});
		} else {
			this.setState({
				expandedIndex: index,
			});
		}
	};

	renderDeviceList = () => {
		const { formApi, values } = this.props;
		const { screenshotsExpanded } = this.state;

		let devices = screenshotDevices.map(t => (
			<GroupCollection
				key={t.option}
				label={t.title}
				expanded={screenshotsExpanded[t.option]}
				toggleGroup={() => this.toggleGroup(t.option)}
			>
				<ScreenshotList values={values} scope={t.option} formApi={formApi} />
			</GroupCollection>
		));
		return devices;
	};

	toggleGroup = key => {
		const { screenshotsExpanded } = this.state;
		const currentKeyState = screenshotsExpanded[key];
		const newScreenshotsExpanded = { ...screenshotsExpanded };
		newScreenshotsExpanded[key] = !currentKeyState;
		this.setState({ screenshotsExpanded: newScreenshotsExpanded });
	};

	render() {
		const { submitForm, values } = this.props;
		return (
			<div>
				<TextInput
					isRequired
					field="bundleId"
					id="bundleId"
					placeholder="Bundle ID"
					validationRegex={BUNDLE_ID}
				/>
				<FileInput isRequired field="icon" id="icon" placeholder="Icon" />
				<TextInput isRequired field="iconName" id="iconName" placeholder="Icon Name" />
				<TextInput isRequired field="displayName" id="displayName" placeholder="Display Name" />
				<TextEditor isRequired field="description" id="description" placeholder="Description" />
				<TextInput isRequired field="shortDescription" id="shortDescription" placeholder="Short Description" />
				<SelectInput
					isRequired
					field="androidCategory"
					id="androidCategory"
					placeholder="Android Category"
					values={androidCategories}
				/>
				{/* <SelectInput field="androidSubCategory" id="androidSubCategory" placeholder="Android Sub Category" /> */}
				<SelectInput
					isRequired
					field="appleCategory"
					id="appleCategory"
					placeholder="Apple Category"
					values={appleCategories}
				/>
				<SelectInput
					field="appleSubCategory"
					id="appleSubCategory"
					placeholder="Apple Sub Category"
					values={appleSubCategories}
				/>
				<TextInput
					isRequired
					field="primaryLanguage"
					id="primaryLanguage"
					placeholder="Primary Language"
					helperText="For the iOS App Store"
				/>
				<SelectInput
					isRequired
					field="primaryTerritory"
					id="primaryTerritory"
					placeholder="Primary Territory"
					helperText="For the iOS App Store"
					values={getTerritoryList()}
				/>
				<TextInput isRequired field="copyright" id="copyright" placeholder="Copyright Info" />
				<TextInput
					isRequired
					field="appleTags"
					id="appleTags"
					placeholder="Apple Tags"
					helperText="Comma separated list of tags"
					validationRegex={APPLE_TAGS}
				/>
				<TextInput
					isRequired
					field="marketingWebsite"
					id="marketingWebsite"
					placeholder="Marketing Website"
					validationRegex={URL}
				/>
				<TextInput isRequired field="supportName" id="supportName" placeholder="Support Name" />
				<TextInput
					isRequired
					field="supportEmailAddress"
					id="supportEmailAddress"
					placeholder="Support Email Address"
					validationRegex={EMAIL}
				/>
				<TextInput
					isRequired
					field="supportPhoneNumber"
					id="supportPhoneNumber"
					placeholder="Support Phone Number"
				/>
				<TextInput
					isRequired
					field="supportUrl"
					id="supportUrl"
					placeholder="Support URL"
					validationRegex={URL}
				/>
				<FileInput
					isRequired
					field="androidFeatureImage"
					id="androidFeatureImage"
					placeholder="Android Feature Image"
				/>
				<TextInput
					field="firebaseProjectId"
					id="firebaseProjectId"
					placeholder="Firebase Project ID"
					disabled
				/>
				<TextInput
					field="firebaseAppleAppId"
					id="firebaseAppleAppId"
					placeholder="Firebase Apple App ID"
					disabled
				/>
				<TextInput
					field="firebaseAndroidAppId"
					id="firebaseAndroidAppId"
					placeholder="Firebase Android App ID"
					disabled
				/>
				<TextInput field="firebaseWebAppId" id="firebaseWebAppId" placeholder="Firebase Web App ID" disabled />
				<TextInput
					field="serviceAccountKey"
					id="serviceAccountKey"
					placeholder="Service Account (JSON)"
					disabled
				/>
				<TextInput field="webConfig" id="webConfig" placeholder="Firebase Web Config (JSON)" disabled />
				<TextInput isRequired field="appleDevTeamId" id="appleDevTeamId" placeholder="Apple Dev Team ID" />
				<TextInput isRequired field="appleMerchantId" id="appleMerchantId" placeholder="Apple Merchant ID" />
				<h4 className="collection-title">Device Screenshots</h4>
				{values && Object.keys(values).length > 0 && this.renderDeviceList()}
				<div style={{ marginTop: "24px" }}>
					<div className="btn btn-success" onClick={() => submitForm(true)}>
						Save Config
					</div>
				</div>
			</div>
		);
	}
}

Form.propTypes = {
	formApi: PropTypes.object,
	submitForm: PropTypes.object,
	values: PropTypes.object,
};

export default withForm(Form);
